import { compose } from 'redux';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { WithAccountId, CommanderThunkDispatch } from '@mews-commander/types';
import { AccountType } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { commanderForm, presence, validation } from '@mews-commander/legacy-form';
import { OTHER_ACCOUNT_ID_FIELD_NAME } from '../constants';
import { mergeAccounts } from '../actions';
import { AccountMergeFormFields } from './AccountMergeFormFields';

export interface AccountMergeFormProps extends WithAccountId {
    form: string;
    accountType: AccountType;
    readOnlyForm?: boolean;
}
interface FormValues {
    [OTHER_ACCOUNT_ID_FIELD_NAME]: string;
}

interface DispatchProps {
    onSubmit: (values: FormValues) => void;
}

const constraints = {
    [OTHER_ACCOUNT_ID_FIELD_NAME]: { presence },
};

export default compose<React.FC<AccountMergeFormProps>>(
    connect<{}, DispatchProps, AccountMergeFormProps>(
        undefined,
        (dispatch: CommanderThunkDispatch, { accountId, form, accountType }) => ({
            onSubmit: (values) => {
                dispatch(reset(form));
                dispatch(mergeAccounts({ accountId, accountType, ...values }));
            },
        })
    ),
    commanderForm({
        enableReinitialize: true,
        validate: validation(constraints),
        submitLabel: <LocalizedText textKey={TextKey.Merge} />,
        submitButtonProps: { variant: 'primary' },
    })
)(AccountMergeFormFields);
